module.exports = __webpack_public_path__ + "static/media/craft-04.f786db8b.svg";